import LoanDrawdownItemTypeEnum from '~Api/Loan/LoanDrawdownItemTypeEnum';
import { IDictionary } from '~utilities/IDictionary';

const loanDrawdownItemTypeLabels: IDictionary<string> = {
    [LoanDrawdownItemTypeEnum.DrawdownFee]: 'Drawdown Fee',
};

export default loanDrawdownItemTypeLabels;
